<template>
  <div class="event-card mdl-card mdl-shadow--3dp">
    <div class="mdl-grid mdl-grid--no-spacing">
      <div
        class="mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
      >
        <meeting-about
          :description="meeting.description"
          :about="meeting.meetingAbout"
          :is-closed="meeting.isClosed"
          :is-expired="meeting.isExpired"
          @openAboutModal="emitAboutModal"
        />
      </div>
      <div
        class="mdl-cell mdl-cell--6-col mdl-cell--12-col-tablet mdl-cell--12-col-phone border"
      >
        <event-details
          :voter="voter"
          :display-options="displayOptions"
          :meeting-date="meeting.meeting_date"
          :meeting-timezone="meeting.meeting_timezone"
          :meeting-location="meeting.location"
          :meeting-documents="meeting.documents"
          :is-closed="meeting.isClosed"
          :is-expired="meeting.isExpired"
          :is-attending="isAttending"
        />
      </div>
      <div
        class="mdl-cell mdl-cell--6-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
      >
        <div class="md-divider" />
        <start-proxy
          :is-closed="meeting.isClosed"
          :is-expired="meeting.isExpired"
          :is-blocked-recast="isBlockedRecast"
          :is-blocked-unit-recast="isBlockedUnitRecast"
          :meeting-timezone="meeting.meeting_timezone"
          :last-voted-at="lastVotedAt"
          :unit-last-voted-at="unitLastVotedAt"
          :short-code="meeting.shortCode"
          :view="view"
          :display-options="displayOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MeetingAbout from '../MeetingAbout.vue';
import EventDetails from '../EventDetails.vue';
import StartProxy from '../StartProxy.vue';
import AboutModal from '../AboutModal.vue';
import RsvpModal from '../RsvpModal';

import _ from 'lodash';

export default {
  name: 'DefaultMode',
  components: {
    MeetingAbout,
    EventDetails,
    StartProxy,
    AboutModal,
    RsvpModal
  },
  props: {
    meeting: {
      type: Object,
      default() {
        return {};
      }
    },
    displayOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    view: {
      type: String,
      default: ''
    },
    isAttending: {
      type: Boolean,
      default: false
    },
    voter: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    isBlockedRecast() {
      if (
        _.get(this.meeting.options, 'block_vote_recasting', false) &&
        _.get(this.meeting, 'voter.lastVotedAt', false)
      ) {
        return true;
      }
      return false;
    },
    isBlockedUnitRecast() {
      if (
        _.get(this.meeting.options, 'block_unit_vote_recasting', false) &&
        _.get(this.meeting, 'voter.lastUnitVotedAt', false)
      ) {
        return true;
      }
      return false;
    },
    unitLastVotedAt() {
      return _.get(this.meeting, 'voter.lastUnitVotedAt', null);
    },
    lastVotedAt() {
      return _.get(this.meeting, 'voter.lastVotedAt', null);
    }
  },
  methods: {
    emitAboutModal() {
      this.$emit('openAboutModal');
    }
  }
};
</script>

<style>
/* Event Cards */
.event-card {
  width: 100%;
  padding-bottom: 20px;
  border-top: solid 4px #3f51b5;
}

.border {
  border-right: 1px solid #e0e0e0;
}
@media only screen and (max-width: 840px) {
  .border {
    border-right: hidden;
  }
}
@media only screen and (min-width: 840px) {
  .md-divider {
    visibility: hidden;
  }
}

@media only screen and (min-width: 767px) {
  /* Additional padding on larger screen */
  .event-card {
    padding-top: 10px;
  }
}

.content-padding {
  margin: 0px 40px;
}
@media only screen and (max-width: 450px) {
  .content-padding {
    margin: 0px 20px;
  }
}
</style>
